import * as css from 'css/exports.module.scss';
import './NotificationsMenu.scss';
import { BellOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { count } from '@sonar-software/sonar-ts-lib';
import { When } from 'react-if';
import { Badge, Col, Dropdown, Row } from 'antd';
import { ClearAllNotifications, NotificationCards } from '../notifications';
import { notificationsActions, SonarNotificationType } from '@sonar-software/sonar-notifications';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useAction, useInterval, useNotifications, useOptimisticUpdate, usePrevious } from '@hooks';
const badgeOffset = [-6, 6];
const triggerEvents = ['click'];
function isNotificationUnread(notification) {
    return !notification.isRead;
}
export const NotificationsMenu = () => {
    const notifications = useNotifications();
    const previousNotifications = usePrevious(notifications);
    const loadNotifications = useAction(notificationsActions.requestGetNotifications);
    const markAllRead = useAction(notificationsActions.requestPatchNotifications);
    const { clear } = useOptimisticUpdate();
    const refreshNotifications = useCallback(() => {
        loadNotifications();
    }, [loadNotifications]);
    useInterval(refreshNotifications, 30000);
    const hasNotifications = Boolean(notifications.length);
    const unreadCount = count(notifications !== null && notifications !== void 0 ? notifications : [], isNotificationUnread);
    const overlayClassNames = classNames('notifications-menu', { empty: !hasNotifications });
    const handleChange = useCallback((visible) => {
        if (visible && unreadCount) {
            markAllRead();
        }
    }, [unreadCount, markAllRead]);
    const newNotifications = useMemo(() => { var _a; return notifications.slice(0, notifications.length - ((_a = previousNotifications === null || previousNotifications === void 0 ? void 0 : previousNotifications.length) !== null && _a !== void 0 ? _a : 0)); }, [notifications, previousNotifications === null || previousNotifications === void 0 ? void 0 : previousNotifications.length]);
    useEffect(() => {
        if (newNotifications.some((notification) => notification.notificationType === SonarNotificationType.SalesforceBulkPatchSummaryReady)) {
            clear();
        }
    }, [clear, newNotifications]);
    return (React.createElement(Dropdown, { destroyPopupOnHide: true, dropdownRender: () => React.createElement(React.Fragment, null,
            React.createElement(When, { condition: hasNotifications },
                React.createElement(Row, { align: 'middle', className: 'notification-menu-actions', justify: 'end' },
                    React.createElement(Col, { span: '12' }),
                    React.createElement(Col, { className: 'align-right', span: '12' },
                        React.createElement(ClearAllNotifications, { id: 'notification-menu-clear-all-button' })))),
            React.createElement("div", { className: 'notification-menu-list' },
                React.createElement(NotificationCards, { height: window.innerHeight - 100, wrapEmpty: true }))), onOpenChange: handleChange, overlayClassName: overlayClassNames, trigger: triggerEvents },
        React.createElement(Badge, { className: 'notifications-menu-icon', color: css.badgeColor, count: unreadCount, offset: badgeOffset, overflowCount: 99 },
            React.createElement(BellOutlined, { id: 'notifications-menu-icon' }))));
};
